import { ModuleFE_AdvisorSnippet } from './ModuleFE_AdvisorSnippet.js';
export const ModulePackFE_AdvisorSnippetDB = [ModuleFE_AdvisorSnippet];
//# sourceMappingURL=module-pack.js.map